import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { AuthService } from 'src/app/core/authentication/auth.service';
import { User } from 'src/app/core/authentication/User';
import { Abilities } from 'src/app/shared/model/Abilities';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-mobile-center-header',
  templateUrl: './mobile-center-header.component.html',
  styleUrls: ['./mobile-center-header.component.scss']
})
export class MobileCenterHeaderComponent implements OnInit {

  @ViewChild("anchor", { static: false })
  public anchor: ElementRef<HTMLElement>;
  
  user: User;
  showUserMenu: boolean;
  profileReferenceType:string;
  brand:string;
  isTrainingEnv:boolean;
  showPopupMenu: boolean;
  canMakeBusinessTripsFromMobile = false;

  @ViewChild("menuAnchor", { static: false })
  public menuAnchor: ElementRef<HTMLElement>;

  @HostListener("click", ["$event"])
  public documentClick(event: MouseEvent): void {
    if (this.showPopupMenu && !this.menuAnchor.nativeElement.contains(event.target as Node)) {
      this.togglePopupMenu();
    }
  }
  
  constructor(private authService: AuthService) {
    this.brand = environment.brand;
    this.isTrainingEnv = environment.isTrainingEnv;
  }

  ngOnInit(): void {
    this.user = this.authService.getLoggedUserInfo();
    this.canMakeBusinessTripsFromMobile = this.authService.hasAbility(Abilities.CanMakeBusinessTripsFromMobile);
  }

  logoutUser(): void {
    this.authService.logout();
  }

  togglePopupMenu() {
    this.showPopupMenu = !this.showPopupMenu;
  }
}
